import ConnexionModel from '../model/ConnexionModel';
import { base_url } from '../utils/variables';

export async function sendConnexion(connexion: ConnexionModel) {
  const fullUrl = base_url + 'connections';

  try {
    const response = await fetch(fullUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(connexion),
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    let res = await response.json();
    return res;
  } catch (error) {
    console.error('Error fetching data:', error);
    return null;
  }
}
